export default __webpack_public_path__ + "static/media/facebook.b3379556.webp";